<template>
  <div>
    <v-divider/>
    <v-layout mt-2 row class="justify-center">
      <v-flex xs2 class="body-2 ml-3">
        {{$t('feeds.audit_status')}}
      </v-flex>
      <v-flex xs2 class="hidden-xs-only body-2 ml-2">
        {{$t('feeds.audit_process_date')}}
      </v-flex>
      <v-flex xs2 class="hidden-xs-only body-2 ml-3">
        {{$t('feeds.audit_start')}}
      </v-flex>
      <v-flex xs2 class="hidden-xs-only body-2 ml-3">
        {{$t('feeds.audit_finish')}}
      </v-flex>
      <v-flex xs2 class="body-2">
        {{$t('feeds.audit_processed')}}
      </v-flex>
      <v-flex xs2 class="body-2 ml-0">
        {{$t('feeds.audit_errored')}}
      </v-flex>
      <v-flex xs2 class="body-2 ml-0">
      </v-flex>
    </v-layout>
    <v-layout mt-2 v-if="!auditLoading" row v-for="processAudit in audits" :key="processAudit.id">
      <v-flex xs2 class="body-2 ml-3">
        <v-icon v-if="processAudit.processEndTimestamp === null">mdi-timelapse</v-icon>
        <v-icon color="warning" v-else-if="processAudit.success && processAudit.recordsErrored > 0">
          mdi-alert-box
        </v-icon>
        <v-icon color="success" v-else-if="processAudit.success">mdi-check</v-icon>
        <v-icon color="error" v-else-if="!processAudit.success">mdi-alert-outline</v-icon>
      </v-flex>
      <v-flex xs2 class="hidden-xs-only ml-2 caption">
        <span style="padding-left: 5px">
          {{processAudit.processDate | date}}
        </span>
      </v-flex>
      <v-flex xs2 class="hidden-xs-only ml-4 caption">
        <span>
          {{processAudit.processStartTimestamp | time}}
        </span>
      </v-flex>
      <v-flex xs2 class="hidden-xs-only body-2 ml-3 caption">
         <span style="padding-left: 5px">
           {{processAudit.processEndTimestamp | nullableTime}}
         </span>
      </v-flex>
      <v-flex xs2 class="body-2 ml-4 caption">
          {{processAudit.recordsProcessed}}
      </v-flex>
      <v-flex xs2 class="body-2 ml-0 caption">
        {{processAudit.recordsErrored}}
      </v-flex>
      <v-flex xs2 class="body-2 ml-0">
        <v-icon v-show="processAudit.success && processAudit.recordsErrored > 0">mdi-information-outline</v-icon>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'
  import {mapActions, mapState} from 'vuex'
  import Colors from '../../mixins/Colors'
  import {
    GET_AUDIT_BREAKDOWN_INFO
  } from '../../store/action-types'
  export default {
    name: 'feed-request-breakdown-info-body',
    props: ['breakdownInfo', 'open'],
    mixins: [DateFormat, Colors],
    data () {
      return {
      }
    },
    methods: {
      changeColors () {
        const bgColor = this.lightenColor(this.$vuetify.theme.primary, 2)
        const textColor = this.getTextColor(bgColor)
        this.$el.parentElement.parentElement.style.backgroundColor = this.open ? bgColor : ''
        this.$el.parentElement.parentElement.style.color = this.open ? textColor : ''
        this.iconStyle = this.open ? {color: textColor} : ''
      },
      ...mapActions({
        getAuditBreakdownInfo: GET_AUDIT_BREAKDOWN_INFO
      })
    },
    computed: {
      ...mapState({
        feedBreakdownInfos: state => state.feeds.breakdownInfos,
        auditLoading: state => state.feeds.auditLoading
      }),
      audits () {
        return this.feedBreakdownInfos.find(x => x.id === this.breakdownInfo.id).processAudits.breakdownAuditInfos
      }
    },
    watch: {
      open (value) {
        if (value) {
          this.$el.style.backgroundColor = '#E0E0E0'
          if (this.breakdownInfo.processAudits.length === 0) {
            this.getAuditBreakdownInfo()
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitor/FeedRequestBreakdownInfoBody.vue